module.exports = __webpack_public_path__ + "img/syukyaku-top-009.65b0c9a3.jpg";